import { useState, useEffect } from "react";
import { checkConsent, CookieConsent } from "./consentManagement";
var useConsent = function() {
    var ref = useState(CookieConsent.Unknown), consent = ref[0], setConsent = ref[1];
    var handleConsentChange = function() {
        setConsent(checkConsent());
    };
    useEffect(function() {
        if (consent === CookieConsent.Unknown) {
            setConsent(checkConsent());
        }
        document.addEventListener("UC:consentChange", handleConsentChange);
        return function() {
            document.removeEventListener("UC:consentChange", handleConsentChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return consent;
};
export { useConsent };
